import { useMentiSpring } from '@mentimeter/motion/spring';
import { animated, easings } from '@react-spring/web';

interface DotProps extends React.ComponentProps<typeof animated.g> {
  x: number;
  y: number;
  label: string;
  radius: number;
  color: string;
  borderColor: string;
  textColor: string;
  disableAnimations: boolean;
}

export const Dot = ({
  x,
  y,
  label,
  radius,
  color,
  borderColor,
  textColor,
  disableAnimations,
  ...rest
}: DotProps) => {
  const [springs] = useMentiSpring({
    from: {
      opacity: 0,
      transform: `translate(${x}px, ${y}px) scale(0.8)`,
    },
    to: {
      opacity: 1,
      transform: `translate(${x}px, ${y}px) scale(1)`,
    },
    config: { duration: 350, easing: easings.easeInOutQuart },
    immediate: disableAnimations,
  });

  return (
    <animated.g
      style={{
        ...springs,
        cursor: 'pointer',
        transformBox: 'fill-box',
        transformOrigin: 'center',
      }}
      {...rest}
    >
      <circle
        fill={color}
        r={radius}
        stroke={borderColor}
        strokeWidth={3}
        cx={0}
        cy={0}
        style={{
          transformBox: 'fill-box',
          transformOrigin: 'center',
          filter: 'drop-shadow(0px 2px 8px  #0000001F)',
        }}
      />

      <text
        x={0}
        y={0}
        textAnchor="middle"
        dominantBaseline="central"
        fill={textColor}
        style={{ fontSize: `${radius}px`, cursor: 'pointer' }}
      >
        {label}
      </text>
    </animated.g>
  );
};
